import axios from "axios";
import config from "./config";

const singIn = (email, password, setSignIn) => {
  var rc = window.grecaptcha;
  var rcKey = window.UI8.recaptchaSiteKey;
  if (!rc || !rcKey) {
    return setSignIn({ error: "Unable to process login" });
  }

  rc.execute(rcKey, { action: "login" }).then((token) => {
    axios
      .post(`${config.LOGIN_SERVER_URL}/account/signin?json=1`, {
        email,
        password,
        next: "/",
        rcToken: token,
      })
      .then((response) => {
        setSignIn({
          error: response.data.error,
          status: "success"
        });
      })
      .catch(() => {
        setSignIn({ error: "Unable to process login" });
      });
  });
};

export default singIn;
